interface Props {
  highlightColor?: string;
  width?: number;
  height?: number;
}

export const ListConfirmedIcon = ({ highlightColor, width, height }: Props) => {
  const color = "#00000";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height={height}
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <title>List Confirmed</title>
      <defs>
        <clipPath id="a8acfb850e">
          <path
            d="M 60 40 L 315 40 L 315 375 L 60 375 Z M 60 40 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <path
        fill={color}
        d="M 206.800781 28.074219 C 204.371094 28.074219 202.40625 26.105469 202.40625 23.679688 C 202.40625 15.484375 195.734375 8.816406 187.535156 8.816406 C 179.339844 8.816406 172.671875 15.484375 172.671875 23.679688 C 172.671875 26.105469 170.703125 28.074219 168.277344 28.074219 C 165.847656 28.074219 163.882812 26.105469 163.882812 23.679688 C 163.882812 10.632812 174.488281 0.0273438 187.535156 0.0273438 C 200.582031 0.0273438 211.191406 10.632812 211.191406 23.679688 C 211.191406 26.105469 209.226562 28.074219 206.800781 28.074219 Z M 206.800781 28.074219 "
        fillOpacity="1"
        fillRule="evenodd"
      />
      <g clipPath="url(#a8acfb850e)">
        <path
          fill={color}
          d="M 284.402344 375.046875 L 90.671875 375.046875 C 73.773438 375.046875 60.023438 361.296875 60.023438 344.398438 L 60.023438 71.074219 C 60.023438 54.175781 73.773438 40.425781 90.671875 40.425781 L 142.761719 40.425781 C 145.195312 40.425781 147.160156 42.398438 147.160156 44.820312 C 147.160156 47.246094 145.195312 49.21875 142.761719 49.21875 L 90.671875 49.21875 C 78.621094 49.21875 68.8125 59.027344 68.8125 71.074219 L 68.8125 344.398438 C 68.8125 356.453125 78.621094 366.265625 90.671875 366.265625 L 284.402344 366.257812 C 296.453125 366.257812 306.261719 356.453125 306.261719 344.398438 L 306.261719 71.074219 C 306.261719 59.027344 296.453125 49.21875 284.402344 49.21875 L 232.308594 49.21875 C 229.878906 49.21875 227.914062 47.246094 227.914062 44.820312 C 227.914062 42.398438 229.878906 40.425781 232.308594 40.425781 L 284.402344 40.425781 C 301.300781 40.425781 315.050781 54.175781 315.050781 71.074219 L 315.050781 344.398438 C 315.050781 361.296875 301.300781 375.046875 284.402344 375.046875 Z M 284.402344 375.046875 "
          fillOpacity="1"
          fillRule="evenodd"
        />
      </g>
      <path
        fill={color}
        d="M 227.980469 70.359375 L 147.09375 70.359375 C 142.289062 70.359375 138.367188 66.445312 138.367188 61.632812 L 138.367188 28.007812 C 138.367188 23.195312 142.289062 19.285156 147.09375 19.285156 L 168.277344 19.285156 C 170.703125 19.285156 172.671875 21.253906 172.671875 23.679688 C 172.671875 26.105469 170.703125 28.074219 168.277344 28.074219 L 147.160156 28.074219 L 147.160156 61.566406 L 227.914062 61.566406 L 227.914062 28.074219 L 206.796875 28.074219 C 204.371094 28.074219 202.398438 26.105469 202.398438 23.679688 C 202.398438 21.253906 204.371094 19.285156 206.796875 19.285156 L 227.980469 19.285156 C 232.785156 19.285156 236.707031 23.195312 236.707031 28.007812 L 236.707031 61.632812 C 236.707031 66.445312 232.785156 70.359375 227.980469 70.359375 Z M 227.980469 70.359375 "
        fillOpacity="1"
        fillRule="evenodd"
      />
      <path
        fill={color}
        d="M 283.710938 349.972656 L 91.359375 349.972656 C 88.9375 349.972656 86.964844 348 86.964844 345.578125 L 86.964844 91.046875 C 86.964844 88.621094 88.9375 86.648438 91.359375 86.648438 L 283.710938 86.648438 C 286.136719 86.648438 288.109375 88.621094 288.109375 91.046875 L 288.109375 345.578125 C 288.109375 348 286.136719 349.972656 283.710938 349.972656 Z M 95.753906 341.179688 L 279.316406 341.179688 L 279.316406 95.441406 L 95.753906 95.441406 Z M 95.753906 341.179688 "
        fillOpacity="1"
        fillRule="evenodd"
      />
      <path
        fill={highlightColor || color}
        d="M 167.808594 251.027344 C 166.644531 251.027344 165.53125 250.566406 164.703125 249.738281 L 147.511719 232.542969 C 145.796875 230.832031 145.796875 228.046875 147.511719 226.332031 C 149.222656 224.617188 152.007812 224.617188 153.722656 226.332031 L 167.808594 240.417969 L 221.34375 186.878906 C 223.066406 185.164062 225.847656 185.164062 227.5625 186.878906 C 229.277344 188.589844 229.277344 191.375 227.5625 193.097656 L 170.921875 249.738281 C 170.09375 250.566406 168.980469 251.027344 167.808594 251.027344 Z M 167.808594 251.027344 "
        fillOpacity="1"
        fillRule="evenodd"
      />
      <path
        fill={highlightColor || color}
        d="M 187.535156 291.46875 C 147.195312 291.46875 114.371094 258.652344 114.371094 218.3125 C 114.371094 177.96875 147.195312 145.144531 187.535156 145.144531 C 227.878906 145.144531 260.703125 177.96875 260.703125 218.3125 C 260.703125 258.652344 227.878906 291.46875 187.535156 291.46875 Z M 187.535156 153.933594 C 152.042969 153.933594 123.160156 182.8125 123.160156 218.3125 C 123.160156 253.804688 152.042969 282.6875 187.535156 282.6875 C 223.027344 282.6875 251.914062 253.804688 251.914062 218.3125 C 251.914062 182.8125 223.027344 153.933594 187.535156 153.933594 Z M 187.535156 153.933594 "
        fillOpacity="1"
        fillRule="evenodd"
      />
    </svg>
  );
};
